import React, { useState } from "react";
import moment from "moment";
import CuStatusMessage from "../components/CuStatusMessage";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import { useMediaQuery } from "react-responsive";
import { useDeleteItem } from "../../_helper/actions/mutation/items";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import MedicalRecordCard from "../components/MedicalRecordCard";
import CuModal from "../../common_component/component/CuModal";
import Confirmation from "../../common_component/component/Confirmation";
import CuMobileModal from "../components/CuMobileModal";
import { getImageURL } from "../../_helper/utils/image";
import ImagePreview from "../../common_component/component/ImagePreview";

const LabTest = ({ data, isLoading }) => {
  const sm = !useMediaQuery({ query: "(min-width:768px)" });
  const [openModal, setOpenModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState("");
  const [openPdfViewer, setOpenPdfViewer] = useState(false);
  const [pdfData, setPdfData] = useState();
  const [mainImage, setMainImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  // //("seleted user--------", selectedUser);
  // const labTestFilter = `?filter[user_id][_eq]=${selectedUser?.id}&filter[record_type][_eq]=1&fields=id,date_created,user_id,file_id,record_type.*,description,name`;
  // const { data: labTestData, isLoading } = useItemsFilter(
  //   "user_records",
  //   labTestFilter
  // );

  // //("items labtest data", labTestData);
  const deleteRecordsMutation = useDeleteItem("users/");

  const handleDelete = (id) => {
    const payload = {
      action: "delUserRecords",
      frontend: "True",
      id: selectedDeleteId,
      clinic_id: 1,
    };
    //(payload, "---payload-----");
    deleteRecordsMutation.mutate(
      { data: payload },
      {
        onSuccess: (data) => {
          //("on delete", data);
          setOpenModal(false);
          setSelectedDeleteId("");
        },
        onError: (data) => {
          //("on Error-----", data);
          setSelectedDeleteId("");
        },
      }
    );
  };

  const handleOpenPdfViewer = (item) => {
    //(item, "PDF viewer here ", item);
    setPdfData(item);
    setOpenPdfViewer(!openPdfViewer);
  };

  return (
    <>
      {isLoading ? (
        <CuScreenLoader />
      ) : (
        <div>
          {data?.length > 0 ? (
            <div className="mt-5">
              {data?.map((item, i) => (
                <div className="mt-5" key={i}>
                  <MedicalRecordCard
                    item={item}
                    title={item?.file_name}
                    date={moment(item.created_At).format("DD MMM YYYY")}
                    // onClick={() => handleClick(item)}
                    handleDelete={() => (
                      setSelectedDeleteId(item?.id), setOpenModal(true)
                    )}
                    handleOpenPdfViewer={() => handleOpenPdfViewer(item)}
                  />
                </div>
              ))}
            </div>
          ) : (
            <CuStatusMessage
              heading={"You don’t have any labtest"}
              description={"Hey you don't have any  labtests"}
              // buttonText={"Book Now"}
              img={cufrontIcons?.NoAppointment}
              // onClick={onClickNavigate}
            />
          )}
          {!!openModal && (
            <CuModal closeModal={() => setOpenModal(false)}>
              <Confirmation
                heading={"Delete Lab Report"}
                onClick={handleDelete}
                onCancel={() => setOpenModal(false)}
                loading={deleteRecordsMutation.isLoading}
              />
            </CuModal>
          )}
        </div>
      )}

      {openPdfViewer && (
        <ImagePreview
          uploadedFile={
            pdfData?.files?.flat().length > 0
              ? pdfData.files.flat()
              : [{ filename: pdfData?.files_id, url: pdfData?.files_id }]
          }
          mainImage={mainImage}
          setMainImage={setMainImage}
          setShowPreview={setOpenPdfViewer}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
        />
      )}
    </>
  );
};

export default LabTest;
